/* @flow */

export default {
  root: {
    width: 28,
    height: 28,
  },
};
